/**
 * 運用管理　定数記録用ファイル
 */

import { Constants } from '@/CommonUtils/fixed/Constants';
import { UketsukeConstants} from '@/Uketsuke/fixed/UketsukeConstants';  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add

// tslint:disable-next-line:no-namespace
export namespace KanriConstants {

  export const KANRI_URL: string = Constants.DOMAIN_URL + Constants.PROJECT_URL + '/kanri';

  // 組織情報
  /** 組織情報パス */
  export const ORG_PATH: string = KANRI_URL + '/organization-info';
  /** 組織情報パス init */
  export const ORG_INIT_PATH: string = ORG_PATH + Constants.PATH_TAIL_INIT;
  /** 組織情報ファイル名 */
  export const ORG_FILE: string = 'OrganizationInfo.json';

  // ユーザ情報
  /** ユーザ情報パス */
  export const USER_PATH: string = KANRI_URL + '/user-info';
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
  // メールテンプレート
  /** メールテンプレートパス */
  export const MAIL_PATH: string = UketsukeConstants.UKETSUKE_URL + '/mail-template';
  /** メールテンプレート貼付用置換文字列name */
  export const REPLACE_STRING_NAME: string = 'replaceString';
  /** メールテンプレートメール本文name */
  export const MAIL_TEXT: string = 'mailText';
  /** メールテンプレートメールテンプレート種別name */
  export const MAIL_TYPE: string = 'mailType';
  /** メールテンプレートメール本文イメージname */
  export const MAIL_TEXT_IMAGE: string = 'mailTextImage';
  /** メール送信スケジュール管理パス */
  export const MAIL_SCHEDULE_PATH: string = KANRI_URL + '/mail-schedule';
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end

  // コードマスタ
  /** コード情報パス */
  export const CODE_PATH: string = KANRI_URL + '/mastercode-info';
  /** コード表情報パス　init */
  export const CODEHYO_INIT_PATH: string = CODE_PATH + Constants.PATH_TAIL_INIT;
  /** コード表情報パス　ソート順：表示順 */
  // export const CODETABLENO_OB_DISPLAY_ORDER_PATH: string = CODE_PATH + '/codetablenoorderbydisplayorder';
  /** コード表情報パス　ソート順：コード番号順 */
  export const CODETABLENO_OB_CODENO_PATH: string = CODE_PATH + '/codetablenoorderbycodeno';
  /** コード情報パス　ソート順：表示順 */
  export const CODE_OB_DISPLAY_ORDER_PATH: string = CODE_PATH + '/codenoorderbydisplayorder';
  /** コード情報パス　ソート順：コード番号順 */
  // export const CODE_OB_CODENO_PATH: string = CODE_PATH + '/codenoorderbycodeno';
}
